import { render, staticRenderFns } from "./LmStaffPostModal.vue?vue&type=template&id=3993a293&"
import script from "./LmStaffPostModal.vue?vue&type=script&lang=ts&"
export * from "./LmStaffPostModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports